<ng-template #content let-c="close">
  <div class="modal-header">
    <h4 class="modal-title">{{_(KEYS.GRID.QUESTIONNAIRE_PREVIEW)}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="c('')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <iframe [src]="previewUrl" *ngIf="previewUrl"></iframe>
  </div>
</ng-template>

<button
  class="btn btn-sm btn-primary d-inline-block mr-1"
  (click)="open(content)"
  data-toggle="tooltip" data-placement="top"
  title="{{_(KEYS.GRID.QUESTIONNAIRE_PREVIEW)}}">
  <i class="fa fa-eye"></i>
</button>
